export function isApp(): boolean {
	return document.querySelector(".is-app") !== null;
}
